import { render, staticRenderFns } from "./SectionProductsEdit.vue?vue&type=template&id=78f7f039&scoped=true&"
import script from "./SectionProductsEdit.vue?vue&type=script&lang=js&"
export * from "./SectionProductsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f7f039",
  null
  
)

export default component.exports